module.exports = __webpack_public_path__ + "img/Frame19.b645cbc4.png";